module.exports = __webpack_public_path__ + "img/icon_zhaocha_logo232.95b55056.png";